query TravelAuthComment($id: UUID!) {
  travelAuthorization(id: $id) {
    __typename
    id
 comment
  }
}
